import React,{useState,useContext} from 'react'
import { InputBox, OtpForm } from '../../components/common';
import validate from "../../validations/FormValidationRules";
import useFormvalidation from '../../validations/FormValidation'
import MasterAction from '../../redux/actions/MasterAction';
import {BsFillForwardFill,BsChevronDown,BsChevronUp} from 'react-icons/bs';
// import { StateContext } from '../components/context/ManageStates';
import { useOrders } from '../../hooks';
import { StateContext } from '../context/ManageStates';
import { useSelector,useDispatch } from 'react-redux';

const ForgotPassword3 = () => {
 const dispatch =useDispatch();
    const [formValues, setFormValues] = useState(
        {
            change_old_password: "",
            change_new_password: "", 
        }
    )

    const {updatepwd} = MasterAction()

    // const { pwd_Email } = useContext(StateContext);
    const pwd_Email = useSelector(state => state.masterdata.pwd_Email);
    const { values, errors, handleChange, handleSubmit,  } = useFormvalidation(
        handleNext,
        validate,
        formValues
    );


 function handleNext() {
    if (localStorage.getItem("verification_method") == 1) {
        var input_data = {
            mobile: pwd_Email,
            password:values.change_old_password
        }
        dispatch(updatepwd(input_data))
    } else {
        var input_data = {
            email: pwd_Email,
            password:values.change_old_password
        }
        dispatch(updatepwd(input_data))
    }
}
      
    return (
        <div className='ForgotPassword-mian-login'>
              <div className='ForgotPassword-main'>
            <div className='ForgotPassword-title'>Create new password</div>
            <div className='ForgotPassword-status'>We'll ask for this password whenever you sign in.</div>
            
          
            <InputBox label={"Old Password"} id={"change_old_password"} handleChange={handleChange} errors={errors} />
            <InputBox label={"New Password"} id={"change_new_password"} handleChange={handleChange} errors={errors} />
            <div className='product-detail-buttongroup login-register-btn'>
                        <div className={`product-detail-button`} onClick={handleSubmit} >
                          Update Password
                        </div>
                    </div>
                    
        </div>
     
      
        </div>
      
    );
};

export default ForgotPassword3;
